import { Grid, Group } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";
import type { ContentfulAdventCalendarSlot } from "../../../common/types/cmsTypes";
import InformationBox from "../../common/informationBox/InformationBox";
import ContestForm from "../ContestForm";
import { getAdventCalendarContest } from "./adventCalendarUtils";

type AdventCalendarContestProps = {
   content: ContentfulAdventCalendarSlot;
};

const AdventCalendarContest = observer(({ content }: AdventCalendarContestProps) => {
   const { prizeImage, prizeText } = content.fields;
   const question = getAdventCalendarContest(content);
   if (!question) {
      return null;
   }
   return (
      <Group className="pb-16">
         <InformationBox theme="christmas" title="Delta i dagens luke og vinn fine premier" className="w-[400px]">
            <Grid cols={{ base: 12 }} gap={4} className="py-7">
               <Grid.Col span={{ base: 3 }}>
                  <div className="aspect-square">
                     {prizeImage ? (
                        <img
                           className="object-cover w-full h-full rounded-lg"
                           src={prizeImage.fields.file?.url}
                           alt={prizeText || "Premie"}
                        />
                     ) : (
                        <div className="w-full h-full rounded-lg bg-base-200" />
                     )}
                  </div>
               </Grid.Col>
               <Grid.Col span={{ base: 9 }}>
                  <p className="text-sm">{prizeText}</p>
               </Grid.Col>
            </Grid>
            <ContestForm id={question.sys.id} entry={question} trackingFormName="Lukepåmelding julekalender" />
         </InformationBox>
      </Group>
   );
});

export default AdventCalendarContest;
